import ResyRouter from './ResyRouter';

export default ResyRouter;
